import { Button, Snackbar, TableRow, Toast } from "@mcleod/components";
import { Api, ModelRow } from "@mcleod/core";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";

export class RowActionCancelSentLoad extends OrderPlanningRowAction {
    public findNearOn: boolean = false;

    get findNearOnColor() {
        return "success";
    }

    override getButton(): Button {
        return this.toolPanel.buttonCancelSentLoad;
    }

    override getButtonId(): string {
        return "buttonCancelSentLoad";
    }

    override getFieldsUsedInThisFile(): string[] {
        return [];
    }

    override async actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): Promise<void> {
        const modelRow = selectedRows[0];
        let isUnitMotive = false;

        if (modelRow.get("driver1_id")) {
            const unitResponse = await Api.search("lme/dispatch/mobilecomm/mc-unit-all",
                { id: modelRow.get("driver1_id"), mc_control_id: "KEEPTRUCK" });
            isUnitMotive = (unitResponse && unitResponse.data && unitResponse.data.length > 0);
        }

        const isTransferredToDriver = modelRow.getBoolean("xmitted2driver");
        const response = await Api.search("lme/dispatch/mobilecomm/mc-control", { id: "KEEPTRUCK", is_active: "Y" });
        const isKeepTruckEnabled = (response && response.data && response.data.length > 0);

        if (!isKeepTruckEnabled || !isTransferredToDriver || !isUnitMotive) {
            this.addReason(reasonMap, "", "Load is not eligible to be cancelled.");
        }
    }

    override async execute(props: PlanningTableRowActionProps) {
        const selectedRows = props.selectedRows;
        const modelRow = selectedRows[0]?.data as ModelRow; // will be changed to multi-select later
        if (modelRow == null)
            return;

        this.cancelSentLoad(selectedRows);
    }

    async cancelSentLoad(selectedRows: TableRow[]) {
        Api.post("lme/dispatch/asset/cancel-zmit-load", { movement_id: selectedRows[0].data.get("movement_id")})
        .catch(e => {
            Snackbar.showWarningSnackbar(e.messages[0]);
        });
    }
}
